import { trackAnalyticsSafely } from "./AnalyticsTracker";
import {
    PlatformNoticeAcknowledgedPayload,
    PlatformNoticeEventPayload,
    PlatformNoticeLinkPayload,
} from "./PlatformNoticesEvents";

export class PlatformNoticesAnalyticsHelper {
    static trackViewed(payload: PlatformNoticeEventPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.PlatformNotices.Viewed",
            payload,
        });
    }

    static trackDismissed(payload: PlatformNoticeEventPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.PlatformNotices.Dismissed",
            payload,
        });
    }

    static trackLinkClicked(payload: PlatformNoticeLinkPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.PlatformNotices.LinkClicked",
            payload,
        });
    }

    static trackAcknowledged(payload: PlatformNoticeAcknowledgedPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.PlatformNotices.Acknowledged",
            payload,
        });
    }
}
